// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.field:not(:last-child),
.field-pair:not(:last-child) {
  margin-bottom: 0.5rem;
}

@media screen and (min-width: 769px), print {
  .field-pair {
    display: flex;
    min-height: 38px;
  }
  .stacked-form .field-pair,
  .stacked-form.field-pair {
    display: block;
  }
  .field-content {
    flex: 1 1;
    min-width: 0;
  }
  .field-label {
    margin-right: 0.5rem;
    text-align: left;
    width: 80px;
    min-width: 80px;
  }
  .stacked-form .field-label {
    width: fit-content;
    text-align: initial;
  }
  .field-body {
    flex: 1;
    max-width: 480px;
  }
}
.field-error-message {
  color: red;
  margin-top: 3px;
}
.field-error-message::before {
  display: inline;
  content: "⚠ ";
}

.field-info-message {
  margin-top: 3px;
}
.field-info-message::before {
  display: inline;
  content: "ℹ️ ";
}

.form-control.has-error {
  border-color: #ff3860;
  background: #ffeeee;
}
.form-control.has-error:focus {
  border-color: #ff3860;
  box-shadow: 0 0 0 0.125em rgba(255, 56, 96, 0.25);
}
.form-control.has-error:active {
  border-color: #ff3860;
  box-shadow: 0 0 0 0.125em rgba(255, 56, 96, 0.25);
}

.form-control:focus,
.form-control.focused {
  background: rgba(134, 182, 254, 0.1254901961);
  box-shadow: none;
  box-shadow: 0 0 0 0.125rem rgba(113, 170, 255, 0.25);
}

.field-decoration-wrapper {
  display: flex;
  background: #f8f8f8;
  padding: 8px 8px 8px 8px;
}
.field-decoration-wrapper .field-decoration-content {
  flex: 1 1;
  align-self: center;
}
.field-decoration-wrapper .field-decoration {
  align-self: center;
}

.array-wrapper > div {
  margin-bottom: 0.5rem;
}

.array-wrapper-moving {
  cursor: grabbing !important;
}
.array-wrapper-moving i,
.array-wrapper-moving .field-decoration-wrapper,
.array-wrapper-moving label,
.array-wrapper-moving input,
.array-wrapper-moving div {
  cursor: grabbing !important;
}

.button-icon {
  outline: none;
  padding: 0;
  vertical-align: initial;
}
.button-icon:focus {
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./packages/aiand-scenario/frontend/src/assets/css/field.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEd;;EAEE,qBAAA;AAAJ;;AAIA;EACE;IACE,aAAA;IACA,gBAAA;EADF;EAGA;;IAEE,cAAA;EADF;EAIA;IACE,SAAA;IAEA,YAAA;EAHF;EAMA;IACE,oBAAA;IACA,gBAAA;IACA,WAAA;IAEA,eAAA;EALF;EAOA;IACE,kBAAA;IACA,mBAAA;EALF;EAOA;IACE,OAAA;IACA,gBAAA;EALF;AACF;AAQA;EACE,UAAA;EACA,eAAA;AANF;AAOE;EACE,eAAA;EACA,aAAA;AALJ;;AASA;EACE,eAAA;AANF;AAOE;EACE,eAAA;EACA,cAAA;AALJ;;AAUE;EACE,qBAAA;EACA,mBAAA;AAPJ;AAQI;EACE,qBAAA;EACA,iDAAA;AANN;AAQI;EACE,qBAAA;EACA,iDAAA;AANN;;AAYA;;EAEE,6CAAA;EACA,gBAAA;EACA,oDAAA;AATF;;AAYA;EACE,aAAA;EAQA,mBAAA;EACA,wBAAA;AAhBF;AAQE;EACE,SAAA;EACA,kBAAA;AANJ;AAQE;EACE,kBAAA;AANJ;;AAYA;EACE,qBAAA;AATF;;AAYA;EACE,2BAAA;AATF;AAUE;;;;;EAKE,2BAAA;AARJ;;AAYA;EACE,aAAA;EACA,UAAA;EACA,uBAAA;AATF;AAUE;EACE,gBAAA;AARJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
